import React from 'react'

import { PageContainer } from 'smart-components'
import { PageContent } from 'components'

const NotFound = () => (
  <PageContainer>
    <PageContent>
      <PageContent.Main>
        <h1>Not found</h1>
      </PageContent.Main>
    </PageContent>
  </PageContainer>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/pages/not-found/index.js